import { apiGet, FormUrlEncodedBody, FormUrlEncodedValue } from './apiClient';

export type RemoteSearchParameters = Record<string, FormUrlEncodedValue>;
export type RemoteSearchResult = Record<string, unknown>;

export interface FlatRemoteSearchOptions {
    url: string;
    parameters?: RemoteSearchParameters;
    searchProperty?: string;
    searchText?: string;
    numParameter?: string;
    selectedCount?: number;
}

interface WrappedRemoteSearchResult<T> {
    result?: T[];
}

export async function getFlatRemoteSearchResults<T extends RemoteSearchResult>(options: FlatRemoteSearchOptions): Promise<T[]> {
    const response = await apiGet<T[] | WrappedRemoteSearchResult<T>>(options.url, buildFlatRemoteSearchQuery(options), { responseType: 'json' });

    if (Array.isArray(response)) {
        return response;
    }

    return Array.isArray(response.result) ? response.result : [];
}

export function buildFlatRemoteSearchQuery(options: FlatRemoteSearchOptions): FormUrlEncodedBody {
    const parameters: RemoteSearchParameters = { ...(options.parameters || {}) };

    if (options.searchText && options.searchProperty) {
        parameters[options.searchProperty] = options.searchText;
    }

    if (options.numParameter && parameters[options.numParameter] !== undefined) {
        parameters[options.numParameter] = addSelectedCount(parameters[options.numParameter], options.selectedCount || 0);
    }

    return parameters;
}

function addSelectedCount(value: FormUrlEncodedValue, selectedCount: number): FormUrlEncodedValue {
    if (typeof value === 'number') {
        return value + selectedCount;
    }

    if (typeof value === 'string') {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue + selectedCount : value;
    }

    return value;
}
